import React from 'react'
import "./Signup.css"
import logoImage from "../../images/Sendbulkmessage.svg";

function Signup() {
  return (
    <div className='isanchaar-signup-Signup'>
      <div className="isanchaar-signup-container">

        <div className="isanchaar-signup-triangle isanchaar-signup-triangle-dark isanchaar-signup-triangle1"></div>
        <div className="isanchaar-signup-triangle isanchaar-signup-triangle-dark isanchaar-signup-triangle2"></div>
        <div className="isanchaar-signup-triangle isanchaar-signup-triangle-dark isanchaar-signup-triangle3"></div>

        <div className="isanchaar-signup-triangle isanchaar-signup-triangle-light isanchaar-signup-triangle4"></div>
        <div className="isanchaar-signup-triangle isanchaar-signup-triangle-light isanchaar-signup-triangle5"></div>
        <div className="isanchaar-signup-triangle isanchaar-signup-triangle-light isanchaar-signup-triangle6"></div>

        <img className='isanchaar-signup-logo-placeholder' src={logoImage} alt="" />
        <p className='isanchaar-signup-heading'>Create Your Account</p>

        <form>
          <div className="isanchaar-signup-form-group">
            <label htmlFor="name">Full Name</label>
            <input type="text" id="name" name="name" required />
          </div>

          <div className="isanchaar-signup-form-group">
            <label htmlFor="email">Work Email</label>
            <input type="email" id="email" name="email" required />
          </div>

          <div className="isanchaar-signup-form-group">
            <label htmlFor="phone">Phone Number</label>
            <input type="tel" id="phone" name="phone" required />
          </div>

          <div className="isanchaar-signup-form-group">
            <label htmlFor="company">Company Name</label>
            <input type="text" id="company" name="company" required />
          </div>

          <div className="isanchaar-signup-form-group">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" name="password" required />
          </div>

          <button type="submit" className="isanchaar-signup-button">Sign Up</button>

          <p className="isanchaar-signup-login-link">
            Already have an account? <a href="/login">Log in</a>
          </p>
        </form>
      </div>
    </div>
  )
}

export default Signup;
